/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/DebouncedModel.js");

module.exports = Model({
	name: "myhealth",
	init: init,
	listeners: listeners,
});

function init() {
	this._list = [];
	this._filter = null;

	this.push({
		bloodoxygen: {},
		bodytemperature: {},
		weight: {},
		bloodpressure: {},
		bloodsugar: {},
		activity: {},
		overview: {},
		comment: {},
		newreading: {},
		feedbackmodal: false,
		customindicator: [],
		customindicatorslist: [],
	});
}

function listeners() {
	return {
		"bloodoxygen:updated": Model.makeExtender("bloodoxygen"),
		"bloodpressure:updated": Model.makeExtender("bloodpressure"),
		"bloodsugar:updated": Model.makeExtender("bloodsugar"),
		"bodytemperature:updated": Model.makeExtender("bodytemperature"),
		"weight:updated": Model.makeExtender("weight"),
		"activity:updated": Model.makeExtender("activity"),
		"overview:updated": Model.makeExtender("overview"),
		"comment:updated": Model.makeExtender("comment"),
		"newreading:updated": Model.makeExtender("newreading"),
		"feedbackmodal:updated": Model.makeExtender("feedbackmodal"),
		"ownstatus:updated": handle_ownstatus_update,
		"atouchawaysettings:updated": Model.makeExtender("settings"),
		"customindicator:updated": Model.makeExtender("customindicator"),
		"customindicatorslist:updated": Model.makeExtender("customindicatorslist")
	};
}

function handle_ownstatus_update(data) {
	if(data.status) {
		var definitions = Object.keys(data.status).map(function(key) {
			return key.split(":")[0];
		});
		this.emit("workflowdefinitions:trigger:track", {
			definitions: definitions
		});
	}
}